import React, { useMemo, useState } from "react";

import { Button, Flex, Modal, Option, Select } from "components";

import { ChangesSummary } from "pages/admin/practiceManagementService/ChangesSummary";
import { usePracticeManagementDiff } from "pages/admin/practiceManagementService/usePracticeManagementDiff";

type CompareVersionsButtonProps = {
  versions: string[];
  className?: string;
};

export const CompareVersionsButton = ({ versions, className }: CompareVersionsButtonProps) => {
  const publishedVersions = useMemo(() => versions.filter((v) => v !== "draft"), [versions]);
  const [open, setOpen] = useState(false);
  const [fromVersion, setFromVersion] = useState<string | undefined>(undefined);
  const [toVersion, setToVersion] = useState<string | undefined>(undefined);

  const effectiveFrom = fromVersion ?? publishedVersions[1];
  const effectiveTo = toVersion ?? publishedVersions[0];

  const { isLoadingDiff, endpointSummaries } = usePracticeManagementDiff(effectiveFrom, effectiveTo, open);

  const handleOpen = () => {
    setFromVersion(undefined);
    setToVersion(undefined);
    setOpen(true);
  };

  return (
    <>
      <Button type="secondary" className={className} onClick={handleOpen} disabled={publishedVersions.length < 2}>
        Compare versions
      </Button>
      <Modal
        showModal={open}
        title="Compare versions"
        onCancel={() => setOpen(false)}
        footer={null}
        wrapClassName="pms-publish-modal"
        content={
          <Flex vertical gap={16} className="padding-50">
            <Flex gap={16}>
              <Select value={effectiveFrom} onChange={setFromVersion} label="From" className="pms-version-select" dataTestId="pms-compare-from-version">
                {publishedVersions.map((v) => (
                  <Option key={v} value={v}>
                    {v}
                  </Option>
                ))}
              </Select>
              <Select value={effectiveTo} onChange={setToVersion} label="To" className="pms-version-select" dataTestId="pms-compare-to-version">
                {publishedVersions.map((v) => (
                  <Option key={v} value={v}>
                    {v}
                  </Option>
                ))}
              </Select>
            </Flex>
            <ChangesSummary isLoading={isLoadingDiff} endpointSummaries={endpointSummaries} fromVersion={effectiveFrom} toVersion={effectiveTo} />
          </Flex>
        }
      />
    </>
  );
};
